import React, { useState } from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const CoursesPage = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const courses = [
    { id: 1, title: "M.Sc in Data Science & Artificial Intelligence", category: "STEM", level: "Postgraduate", duration: "1 - 2 Years", avgFee: "$28,000 / yr", jobs: "AI Engineer, Data Scientist", icon: "fa-brain" },
    { id: 2, title: "International MBA (Full Time)", category: "Business", level: "Postgraduate", duration: "1 Year", avgFee: "£34,000 / yr", jobs: "Management Consultant, Product Manager", icon: "fa-briefcase" },
    { id: 3, title: "B.Sc in Software Engineering", category: "STEM", level: "Undergraduate", duration: "3 - 4 Years", avgFee: "CAD 32,000 / yr", jobs: "Fullstack Developer, Software Architect", icon: "fa-laptop-code" },
    { id: 4, title: "M.Sc in Finance & Investment Banking", category: "Business", level: "Postgraduate", duration: "1 Year", avgFee: "€22,000 / yr", jobs: "Financial Analyst, Investment Banker", icon: "fa-chart-line" },
    { id: 5, title: "Master of Public Health (MPH)", category: "Healthcare", level: "Postgraduate", duration: "2 Years", avgFee: "$25,000 / yr", jobs: "Healthcare Specialist, Epidemiologist", icon: "fa-user-md" },
    { id: 6, title: "M.Sc in Cyber Security & Digital Forensics", category: "STEM", level: "Postgraduate", duration: "1 Year", avgFee: "AUD 38,000 / yr", jobs: "Security Analyst, Penetration Tester", icon: "fa-shield-alt" },
  ];

  const filtered = courses.filter((c) => {
    const matchesSearch = c.title.toLowerCase().includes(searchTerm.toLowerCase()) || c.jobs.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCat = activeCategory === "all" || c.category.toLowerCase() === activeCategory.toLowerCase();
    return matchesSearch && matchesCat;
  });

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* Header */}
      <section className="py-5 consultancy-section-dark text-center">
        <div className="container">
          <span className="consultancy-badge-gold mb-2">Academic Programs</span>
          <h1 className="display-5 font-weight-bold consultancy-gold-title mb-3">Global Course Explorer</h1>
          <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "650px" }}>
            Browse thousands of accredited Bachelor's, Master's, MBA, and PhD degree programs across top international universities.
          </p>

          <div className="row g-2 justify-content-center mx-auto" style={{ maxWidth: "650px" }}>
            <div className="col-md-8">
              <input
                type="text"
                className="form-control consultancy-form-control text-center"
                placeholder="Search course title or career goal..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* Category Tabs */}
          <div className="d-flex justify-content-center flex-wrap gap-2 mt-4">
            {["all", "STEM", "Business", "Healthcare"].map((cat) => (
              <button
                key={cat}
                className={`btn btn-sm rounded-pill font-weight-bold px-4 ${activeCategory === cat ? "btn-warning text-dark" : "btn-outline-secondary text-white"}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Course Grid */}
      <section className="py-5 container">
        <div className="row g-4">
          {filtered.map((c) => (
            <div key={c.id} className="col-lg-4 col-md-6">
              <div className="consultancy-glass-card p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="avatar bg-soft-warning text-warning p-3 rounded-circle">
                      <i className={`fas ${c.icon} fa-lg`}></i>
                    </div>
                    <span className="bg-warning text-dark font-weight-bold px-2 py-1 rounded small">{c.level}</span>
                  </div>

                  <h5 className="font-weight-bold consultancy-gold-title mb-2">{c.title}</h5>

                  <div className="small text-muted mb-2">
                    <i className="fas fa-clock text-warning mr-2"></i> Duration: <strong className="text-white">{c.duration}</strong>
                  </div>
                  <div className="small text-muted mb-2">
                    <i className="fas fa-coins text-warning mr-2"></i> Average Fee: <strong className="text-white">{c.avgFee}</strong>
                  </div>
                  <div className="small text-muted mb-3">
                    <i className="fas fa-briefcase text-warning mr-2"></i> Top Careers: <strong className="text-white">{c.jobs}</strong>
                  </div>
                </div>

                <Link to="/consultancy/book-consultation" className="consultancy-btn-gold w-100 text-center py-2">
                  Apply for this Course <i className="fas fa-chevron-right ml-1"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default CoursesPage;
